import NamedIcon from "components/icons/NamedIcon";

import LinkedTableView from "./LinkedTableView";
import { linkedTabName } from "./linkedTabs";

// SidebarDetailLayout sections for a record's linked custom tables.
export const linkedTabSections = (linkedTabs, recordId) =>
  linkedTabs.map(entry => {
    const LinkedTabIcon = props => (
      <NamedIcon name={entry.icon_name} {...props} />
    );
    return {
      key: linkedTabName(entry),
      label: entry.display_name,
      icon: LinkedTabIcon,
      content: (
        <LinkedTableView
          slug={entry.slug}
          fieldId={entry.field_id}
          recordId={recordId}
        />
      ),
    };
  });
